import { formatBrDateLocal } from '@/lib/format';

/**
 * De quando são os dados desta tela.
 *
 * A página dizia "Última atualização: 08/09/2026" e isso era a data em que o
 * sync RODOU, não a do dado. A Servopa republica o relatório de inadimplentes
 * de tempos em tempos; em setembro de 2026 foram quatro dias servindo o mesmo
 * PDF (gerado em 04/09 às 19:55), cada dia carimbado como leitura nova. Quem
 * lia a tela via um número de hoje que era de quatro dias atrás — e essa mesma
 * lista bloqueia lance, então cliente que pagou seguia barrado.
 *
 * Agora a frase diz a data do RELATÓRIO. Quando ele está velho, diz há quantos
 * dias — o número com o porquê, para a pessoa saber o quanto confiar.
 */

/** A partir daqui o atraso é digno de nota na tela (o sync avisa no log igual). */
export const DIAS_RELATORIO_VELHO = 2;

export function textoOrigemDosDados({
  relatorioEm,
  syncDate,
  agora = new Date(),
}: {
  relatorioEm?: string | null;
  syncDate?: string | null;
  agora?: Date;
}): string | undefined {
  // Linhas anteriores à migration 173 não têm a data do relatório. Aí só dá
  // para dizer quando baixamos — e a frase não promete mais que isso.
  if (!relatorioEm) {
    return syncDate ? `Baixado em ${formatBrDateLocal(syncDate)}` : undefined;
  }

  const gerado = new Date(relatorioEm);
  if (Number.isNaN(gerado.getTime())) {
    return syncDate ? `Baixado em ${formatBrDateLocal(syncDate)}` : undefined;
  }

  const base = `Relatório da Servopa de ${formatBrDateLocal(relatorioEm)}`;
  const dias = Math.floor((agora.getTime() - gerado.getTime()) / 86_400_000);
  if (dias < DIAS_RELATORIO_VELHO) return base;
  return `${base} · sem relatório novo há ${dias} dias`;
}
